export const alcohol = {
  NO: 'NO',
  LESS_14: 'LESS_14',
  MORE_14: 'MORE_14'
}

export const diabetes = {
  YES: 'YES',
  NO: 'NO'
}

export const sugar = {
  NO: 'NO',
  LESS_25: 'LESS_25',
  MORE_25: 'MORE_25'
}

export const infarction = {
  YES: 'YES',
  NO: 'NO'
}

export const issues = {
  STOMACH: 'STOMACH',
  HEARTH: 'HEARTH',
  SKIN: 'SKIN'
}

export const issuesHearth = {
  DISCOMFORT: 'DISCOMFORT',
  PHYSICAL: 'PHYSICAL',
  BLOOD_PRESSURE: 'BLOOD_PRESSURE',
  PULSE: 'PULSE'
}

export const issuesOther = {
  STEW: 'STEW',
  URINATION: 'URINATION',
  WEAKNESS: 'WEAKNESS',
  SWELLING: 'SWELLING',
  KIDNEYS: 'KIDNEYS',
  JOINTS: 'JOINTS',
  TEMPERATURE: 'TEMPERATURE',
  OVERWEIGHT: 'OVERWEIGHT',
  NERVOUS: 'NERVOUS',
  SLEEPY: 'SLEEPY'
}

export const issuesSkin = {
  NAILS: 'NAILS',
  HAIR: 'HAIR',
  SWEATING: 'SWEATING',
  ITCHY: 'ITCHY'
}

export const issuesStomach = {
  ACID: 'ACID',
  PAIN: 'PAIN',
  DISCOMFORT: 'DISCOMFORT',
  NAUSEA: 'NAUSEA'
}

export const joints = {
  YES: 'YES',
  NO: 'NO'
}

export const oncological = {
  YES: 'YES',
  NO: 'NO'
}

export const running = {
  YES: 'YES',
  NO: 'NO'
}

const runningDistance = {
  LESS_20: 'LESS_20',
  MORE_20: 'MORE_20'
}

export const smoking = {
  YES: 'YES',
  NO: 'NO'
}

const tests = {
  OPTIMAL: 'OPTIMAL',
  STRESS: 'STRESS',
  SPORT: 'SPORT',
  ISSUES: 'ISSUES'
}

export const reasons = {
  PERIODICALLY: 'PERIODICALLY',
  STRESS: 'STRESS',
  SPORT: 'SPORT',
  PROBLEMS: 'PROBLEMS'
}

export default {
  alcohol,
  diabetes,
  sugar,
  infarction,
  issues,
  issuesHearth,
  issuesOther,
  issuesSkin,
  issuesStomach,
  joints,
  oncological,
  running,
  runningDistance,
  smoking,
  tests
}

export const QUESTIONS_COMMON = [
  'PlanQuizHeight', // 1
  'PlanQuizWeight',
  'PlanQuizSmoking',
  'PlanQuizAlcohol',
  'PlanQuizSugar',
  'PlanQuizDiabetes',
  'PlanQuizOncological',
  'PlanQuizInfarction',
  'PlanQuizJoints',
  'PlanQuizReasonsForTest'
]
export const STEPS_CONGRATS = 'PlanQuizCongrats'
export const QUESTIONS_SPORT = ['PlanQuizRunning', 'PlanQuizRunningDistance']
export const QUESTIONS_HEALTH = [
  'PlanQuizIssues',
  'PlanQuizIssuesStomach',
  'PlanQuizIssuesHearth',
  'PlanQuizIssuesSkin',
  'PlanQuizIssuesOther'
]
export const STEPS_SUMMARY = 'PlanQuizSummary'

export const STEPS = [
  ...QUESTIONS_COMMON,
  STEPS_CONGRATS,
  ...QUESTIONS_SPORT,
  ...QUESTIONS_HEALTH,
  STEPS_SUMMARY
]
